"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteTrackingPageModal = void 0;
const react_1 = __importDefault(require("react"));
const client_1 = require("@apollo/client");
const react_error_boundary_1 = require("react-error-boundary");
const polaris_1 = require("@shopify/polaris");
const AccountContext_1 = require("contexts/AccountContext");
const graphql_1 = require("components/Dashboard/TrackingPages/graphql");
const styles_1 = require("./styles");
const DeleteTrackingPageModal = ({ active, selectedTrackingPage, onChangeSuccessAlert, onChangeSuccessTitle, onClose, onScrollToTop }) => {
    const handleError = (0, react_error_boundary_1.useErrorHandler)();
    const { account, setAccount } = (0, AccountContext_1.useAccount)();
    const [deleteTrackingPage, { error }] = (0, client_1.useMutation)(graphql_1.DELETE_TRACKING_PAGE, {
        refetchQueries: [{ query: graphql_1.GET_TRACKING_PAGES }, 'externalTrackingPage'],
        onCompleted: () => {
            if (account && selectedTrackingPage && selectedTrackingPage.isDefault) {
                setAccount(Object.assign(Object.assign({}, account), { defaultTrackingPageUrl: null }));
            }
            onChangeSuccessAlert();
            onClose();
            onScrollToTop();
        }
    });
    if (error) {
        handleError(error);
    }
    return (react_1.default.createElement(polaris_1.Modal, { onClose: onClose, open: active, primaryAction: {
            content: 'Delete',
            onAction: () => {
                if (!selectedTrackingPage) {
                    throw new Error('No tracking page selected');
                }
                if (!account) {
                    throw new Error('No account selected');
                }
                deleteTrackingPage({
                    variables: {
                        input: { id: selectedTrackingPage.id, accountId: account.id }
                    }
                }).then(() => {
                    onChangeSuccessTitle(`'${selectedTrackingPage === null || selectedTrackingPage === void 0 ? void 0 : selectedTrackingPage.title}' has been deleted`);
                });
            }
        }, secondaryActions: [
            {
                content: 'Cancel',
                onAction: onClose
            }
        ], title: 'Delete Page' },
        react_1.default.createElement(polaris_1.Modal.Section, null,
            react_1.default.createElement(styles_1.Text, null, "Are you sure? There's no turning back once you've deleted a tracking page."),
            (selectedTrackingPage === null || selectedTrackingPage === void 0 ? void 0 : selectedTrackingPage.isDefault) && (react_1.default.createElement(polaris_1.Banner, { title: 'This page is set as your default tracking page URL', tone: 'warning' },
                react_1.default.createElement("p", null,
                    "You'll need to set a new default tracking page on the",
                    ' ',
                    react_1.default.createElement(styles_1.Span, null, "Account Page"),
                    "."))))));
};
exports.DeleteTrackingPageModal = DeleteTrackingPageModal;
